export default __webpack_public_path__ + "static/media/batchFilledIcon.b5598b88.svg";